import { Icon } from "@iconify/react";
import { HashLink as Link } from "react-router-hash-link";
import scrollToTop from "../components/scrolltotop";
import noscrollOffset from "../components/noscroll-offset";
const Footer = () => {
  return (
    <>
      <div className="footer-container">
        <Link to="/" className="small-desktop-fl">
          <img
            src="https://d1sq738v7irhr2.cloudfront.net/design-system/citos-logo.webp"
            alt="citos logo"
          />
        </Link>
        <div className="footer-top">
          <Link to="/" className="desktop-fl">
            <img
              src="https://d1sq738v7irhr2.cloudfront.net/design-system/citos-logo.webp"
              alt="citos logo"
            />
          </Link>
          <div className="sect">
            <h4>Our subjects</h4>

            <Link to="/subjects/maths" onClick={scrollToTop}>
              <span>Mathematics</span>
            </Link>
            <Link to="/subjects/english" onClick={scrollToTop}>
              <span>English</span>
            </Link>
            <Link to="/subjects/non-verbal-reasoning" onClick={scrollToTop}>
              <span>Non-Verbal Reasoning</span>
            </Link>
            <Link to="/subjects/verbal-reasoning" onClick={scrollToTop}>
              <span>Verbal Reasoning</span>
            </Link>
          </div>
          <div className="sect">
            <h4>Our courses</h4>
            <Link to="/courses/full11-g2" onClick={scrollToTop}>
              <span>Full 11+ Course</span>
            </Link>
            <Link to="/courses/core11-g2" onClick={scrollToTop}>
              <span>11+ Core</span>
            </Link>
            <Link to="/courses/reason11-g2" onClick={scrollToTop}>
              <span>11+ Reasoning</span>
            </Link>
            <Link to="/courses" onClick={scrollToTop}>
              <span>View all courses</span>
            </Link>
          </div>
          <div className="sect">
            <h4>Useful Links</h4>
            <Link to="/assessment" onClick={scrollToTop}>
              <span>Book a free assessment</span>
            </Link>
            <Link to="/subjects#faq-sect" scroll={noscrollOffset}>
              <span>FAQs</span>
            </Link>
            <Link to="/#review-sect" scroll={noscrollOffset}>
              <span>Reviews</span>
            </Link>
            <Link to="/contact" onClick={scrollToTop}>
              <span>Contact us</span>
            </Link>
          </div>
        </div>
        <div className="footer-sm">
          {/* <a href="/">
            <Icon icon="ic:baseline-facebook" className="icon" />
          </a>*/}
          <a href="https://www.instagram.com/citoslearners?igsh=aWVveDBoYzlnNm9r">
            <Icon icon="mdi:instagram" className="icon" />
          </a>
          <a href="https://wa.me/message/F2IMLPUVCCRMP1">
            <Icon icon="ic:baseline-whatsapp" className="icon" />
          </a>
          <a href="https://www.tiktok.com/@citoslearners?_r=1&_t=ZN-91xHnMWe3Hi">
            <Icon icon="ic:baseline-tiktok" className="icon" />
          </a>
        </div>
        <div className="footer-bottom">
          <hr />
          <span>
            ©2025 Cito’s Learners - Powered by{" "}
            <a href="https://www.acrylicwebstudios.com/">Acrylic Web Studios</a>{" "}
            - All rights reserved{" "}
          </span>
        </div>
      </div>
    </>
  );
};

export default Footer;
